<script>
    import Tabs from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Tabs.svelte?1733898724634';
    import Tab from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Tab.svelte?1733898724634';
    import Description from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/tab/Description.svelte?1733898724634';
    import Info from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/tab/Info.svelte?1733898724634';
    import { onMount } from 'svelte';
    import { get_hash, update_hash } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url_hash.js?1733898724634';

    wyvr: {
        render: 'hydrate';
        loading: 'interact';
        trigger: 'found_product_tab_hash';
    }

    export let product;
    export let brand;
    export let store;

    const tabs = [
        { id: 'product-description', title: window.__('product.description') },
        { id: 'product-info', title: window.__('product.info') },
    ];

    let selected_index = 0;
    let content = '';
    let check_hash_script;
    const id = 'product-detail-tab';

    function change(e) {
        const data = e.detail;
        if (!data?.tab || data?.index == undefined) {
            return;
        }
        selected_index = data.index;
        update_hash({ tab: data.tab.id });
    }

    ;
    onMount(() => {
        content = getStack('typo3_service_box');
        const hash = get_hash();
        if (hash && hash.tab) {
            let tab_index;
            const tab = tabs.find((tab, index) => {
                if (tab.id === hash.tab) {
                    tab_index = index;
                    return true;
                }
                return false;
            });

            if (tab) {
                change({ detail: { index: tab_index, tab } });
                document.getElementById(id).scrollIntoView({ block: 'nearest' });
            }
        }
    });
</script>

<Tabs {id} {tabs} {store} bind:selected_index on:change={change}>
    {#if selected_index == 0}
        <Tab id="product-description">
            <Description {product} />
        </Tab>
    {:else if selected_index == 1}
        <Tab id="product-info">
            <Info {product} {brand} />
        </Tab>
    {/if}
    <div slot="content">{@html content}</div>
</Tabs>
{#if false}
    {@html check_hash_script}
{/if}
